import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2265874110/src/src/app/ui/common/side-menu.tsx");
